import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Hero from "@/components/home/Hero";
import Marquee from "@/components/home/Marquee";
import Services from "@/components/home/Services";
import HowItWorks from "@/components/home/HowItWorks";
import JoinSection from "@/components/home/JoinSection";
import Contact from "@/components/home/Contact";
import { scrollToId } from "@/components/site/SmoothScroll";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 300);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <HowItWorks />
      <JoinSection />
      <Contact />
      <Footer />
    </main>
  );
}
